import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RoleGaurd } from 'src/app/shared/services/role-gaurd.service';
import { SettingsComponent } from './settings/settings.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { CustomerManagementComponent } from './customer-management/customer-management.component';
import { CompanyManagementComponent } from './company-management/company-management.component';
import { ManagementComponent } from './management/management.component';
import { DisposeSamplesComponent } from './dispose-samples/dispose-samples.component';

const routes: Routes = [
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin'],
    },
    pathMatch: 'full',
  },
  {
    path: 'access-management',
    component: ManagementComponent,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin'],
    },
    pathMatch: 'full',
  },
  {
    path: 'company-management',
    component: CompanyManagementComponent,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin'],
    },
    pathMatch: 'full',
  },
  {
    path: 'dispose-samples',
    component: DisposeSamplesComponent,
    canActivate: [MsalGuard, RoleGaurd],
    data: {
      roles: ['Admin', 'Manager'],
    },
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
